import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthContainer } from '../components/AuthComponents';
import { AdminAdvisorSponsorInviteForm, BackToDashboardButton, Toast } from '@/components';
import { selectAdvisorAdminPortalState } from '@/model/selectors';
import { resetAdvisorAdminPortal } from '@/model/advisorAdminPortalModel';
import { AdminAdvisorForm } from '@/components/AdminAdvisorForm';
import { AdminAdvisorReportingAttributesForm } from '@/components/AdminAdvisorReportingAttributesForm';
import { AdminAdvisorFeatureFlagsForm } from '@/components/AdminAdvisorFeatureFlagsForm';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
export function WizardAdvisorAdminPortal() {
  const [selectedSection, setSelectedSection] = useState<string>('advisor-fields');
  const dispatch = useDispatch();
  const { status, successMessage } = useSelector(selectAdvisorAdminPortalState);

  const sections = [
    {
      value: 'advisor-fields',
      label: 'Advisor Fields',
      content: <AdminAdvisorForm />,
    },
    {
      value: 'feature-flags',
      label: 'Feature Flags',
      content: <AdminAdvisorFeatureFlagsForm />,
    },
    {
      value: 'reporting-attributes',
      label: 'Reporting Attributes',
      content: <AdminAdvisorReportingAttributesForm />,
    },
    {
      value: 'sponsorship',
      label: 'Sponsorship',
      content: <AdminAdvisorSponsorInviteForm />,
    },
  ];

  const selectedSectionData = sections.find(s => s.value === selectedSection);

  return (
    <AuthContainer
      title="Advisor Admin Portal"
      successState={false}
      isLoading={false}
      warningState={false}
      outsideBoxChildren={<BackToDashboardButton className="justify-center" />}
    >
      <div className="mx-auto max-w-2xl px-4 pb-4">
        <div className="mb-6">
          <label className="mb-2 block text-sm font-medium text-gray-700">Select Section</label>
          <Select
            value={selectedSection}
            onValueChange={setSelectedSection}
          >
            <SelectTrigger className="w-full text-gray-700">
              <SelectValue placeholder="Select a section" />
            </SelectTrigger>
            <SelectContent>
              {sections.map(section => (
                <SelectItem
                  key={section.value}
                  value={section.value}
                >
                  {section.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="mt-6">{selectedSectionData?.content}</div>
      </div>
      <Toast
        show={status === 'success'}
        onClose={() => dispatch(resetAdvisorAdminPortal())}
        title={successMessage ?? ''}
        autoCloseDuration={7000}
      />
    </AuthContainer>
  );
}
